import { TiCardActor, TiCardGeneralData } from "../../../../../@types";

// eslint-disable-next-line no-shadow
export enum AdditionalInformationType {
  Threat = "threat",
  Actor = "actor",
  Closed = "closed"
}

type AdditionalInformationActorAction = {
  type: AdditionalInformationType.Actor;
  data: TiCardActor;
};

type AdditionalInformationThreatAction = {
  type: AdditionalInformationType.Threat;
  data: TiCardGeneralData;
};

type AdditionalInformationCloseAction = {
  type: AdditionalInformationType.Closed;
};

export type AdditionalInformationState =
  | AdditionalInformationActorAction
  | AdditionalInformationThreatAction
  | AdditionalInformationCloseAction;

export type AdditionalInformationAction = AdditionalInformationState;
